import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue';
import { useI18n } from '@/helpers/composables/useI18n';
import GridBuyBox from '@/features/buybox/components/grid/GridBuyBox.vue';
import UpcomingContent from '@/components/upcoming/UpcomingContent.vue';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { ObjectType, UpcomingRelease } from '@/@types/graphql-types';
import { SnowplowContext, SnowplowTitleContextGraphql } from '@/helpers/tracking/providers/snowplow-contexts';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import type { EpisodeFragment } from '@/pages/graphql/fragments/Episode.fragment';
import type { SponsoredAdFragment } from '@/pages/graphql/fragments/SponsoredAd.fragment';
import ListBuyBox from '@/features/buybox/components/list/ListBuyBox.vue';
import { NewBuyBoxView } from '@/stores/user.store';
import BuyBoxTypeSwitcher from '@/features/buybox/components/BuyBoxTypeSwitcher.vue';
import { useUserStore } from '@/helpers/composables/useStores';
import MarkAsSeenButtonGraphql from '@/components/list/title-card/MarkAsSeenButton/MarkAsSeenButtonGraphql.vue';

import { useProvideOfferEntityId } from '@/helpers/composables/useProvideClickoutPlacement';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'EpisodesListItem',
  props: {
    title: null,
    episode: null,
    titleId: null,
    titleObjectId: null,
    titleName: null,
    isTitleInWatchlist: { type: Boolean, default: false },
    showSeenProgress: { default: 0 },
    additionalContexts: { default: () => [] },
    sponsoredAd: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { title: TitleDetail, episode: EpisodeFragment, titleId: string, titleObjectId: number, titleName: string, isTitleInWatchlist: boolean, showSeenProgress: number, additionalContexts: SnowplowContext[], sponsoredAd: SponsoredAdFragment | undefined };



useProvideOfferEntityId(props.episode.id);

const { t } = useI18n();
const { showOldTitlePage } = useUserStore();

const expanded = ref(false);
const episodeItem = ref<HTMLLIElement | null>(null);

const showDetails = computed(() => ({
	id: props.titleId,
	title: props.titleName,
	objectId: props.titleObjectId,
	objectType: ObjectType.Show,
}));

const { isLoggedIn } = useUserStore();

const isUpcoming = computed(() => {
	return !props.episode.content.isReleased && props.episode.content.upcomingReleases.length > 0;
});

const upcomingEpisodeReleases = computed(() => {
	return props.episode.content.upcomingReleases.filter(el => el.__typename == 'UpcomingRelease') as UpcomingRelease[];
});

const description = computed(() => {
	return props.episode.content.shortDescription || t('WEBAPP_NO_DESCRIPTION');
});

const isSeason = computed(() => props.title.__typename === 'Season');
// keeping this one as Next we will have a toggle that shows the old TitlePage + the old BB only
const isGridViewOnly = computed(() => showOldTitlePage.value);

const buyBoxType = ref(isGridViewOnly.value ? NewBuyBoxView.GRID : NewBuyBoxView.LIST);

watch(isGridViewOnly, value => {
	buyBoxType.value = value ? NewBuyBoxView.GRID : NewBuyBoxView.LIST;
});

const showNewBuybox = computed(() => {
	if (isGridViewOnly.value) {
		return false;
	}
	return buyBoxType.value === NewBuyBoxView.LIST;
});

function handleBuyBoxTypeChange(payload: { buyBoxType: NewBuyBoxView }) {
	buyBoxType.value = payload.buyBoxType;
}

async function toggle(location?: 'button') {
	// INP case: artificially give the JS thread time to breathe by adding a re-render.
	await new Promise(resolve => setTimeout(resolve, 0));
	expanded.value = !expanded.value;

	TrackingHelper.trackEvent(
		'userinteraction',
		{
			action: 'toggle_episode',
			label: props.episode.content.episodeNumber + '',
			property: location,
			value: expanded.value ? 1 : 0,
		},
		[
			new SnowplowTitleContextGraphql(
				props.titleObjectId,
				ObjectType.Show,
				props.episode.content.seasonNumber,
				props.episode.content.episodeNumber
			),
		]
	);

	if (expanded.value) {
		episodeItem.value?.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}
}

return { __sfc: true,props, t, showOldTitlePage, expanded, episodeItem, showDetails, isLoggedIn, isUpcoming, upcomingEpisodeReleases, description, isSeason, isGridViewOnly, buyBoxType, showNewBuybox, handleBuyBoxTypeChange, toggle, GridBuyBox, UpcomingContent, ObjectType, ListBuyBox, BuyBoxTypeSwitcher, MarkAsSeenButtonGraphql, faChevronDown, faChevronUp }
}

})